import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import { MultiStyleText } from "slotworks/graphics/pixi/pixi-multistyle-text";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import Result from "slotworks/model/gameplay/records/results/result";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import WaysResult from "slotworks/model/gameplay/records/results/ways-result";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";

export default class FooterComponent {
    public static layer: Layers = null;

    protected textValue: string = "";
    protected text: FlexiText;

    constructor() {
        this.refresh();
        this.showDefaultText();

        FooterComponent.layer.onSceneEnter.add(() => this.refresh());
    }

    public showBlank() {
        this.setText("");
    }

    public showNoWin() {
        this.setText(Services.translations.get("fot.no"));
    }

    public showSpinStart(betValue: number) {
        this.setText(Services.translations.get("fot.pla", { bet: Services.currency.format(betValue) }));
    }

    public showFreespinStart() {
        const id = "fot.fpl";
        const message = Services.translations.get(id);

        if (id !== message) {
            this.setText(message);
        } else {
            this.showBlank();
        }
    }

    public showGameWin(winValue: number) {
        this.setText(Services.translations.get("fot.gam", { credits: Services.currency.format(winValue) }));
        return Contract.empty();
    }

    public showCustomResult(result: Result, textKey: string, args: any) {
        this.setText(Services.translations.get(textKey, args));
        return Contract.empty();
    }

    public showScatterWin(result: ScatterResult) {
        const win = Services.currency.format(result.cashWon);
        this.setText(Services.translations.get("fot.sca", { win }));
    }

    public showLineWin(result: LineResult, symbol?: string) {
        const win = Services.currency.format(result.cashWon);
        this.setText(Services.translations.get("fot.lin", { line: result.line + 1, linewin: win, win, matches: result.matches, symbol }));
        return Contract.empty();
    }

    public showWaysWin(result: WaysResult, symbol: string) {
        const winData = {
            payout_per_symbols: Services.currency.format(result.perWayPayout),
            number_of_ways: result.ways,
            total_payout: Services.currency.format(result.cashWon),
            triggered: 0
        };

        if (result.linkedResult instanceof FreespinWinResult) {
            winData.triggered = result.linkedResult.freespinsWon;
        }

        let message = result.ways > 1 ? "fot.ways" : "fot.way";

        if (winData.triggered > 0) {
            message = result.ways > 1 ? "fot.trs" : "fot.tri";
        }

        this.setText(Services.translations.get(message, winData));
    }

    public showMiscWin(textId: string) {
        this.setText(Services.translations.get(textId));
    }

    public showFreeSpinsTriggered(freespinsWon?: number) {
        const id = "fot.fre";
        const message = Services.translations.get(id, { freespins: freespinsWon });

        if (id !== message) {
            this.setText(message);
        }
    }

    public showFreeSpinsRetriggered(freespinsWon?: number) {
        const id = "fot.ret";
        const message = Services.translations.get(id, { freespins: freespinsWon, SPINS: freespinsWon });

        if (id !== message) {
            this.setText(message);
        }
    }

    public showCustomMessage(message: string) {
        this.setText(message);
    }

    public showDefaultText() {
        this.setText(Services.translations.get("fot.new"));
    }

    protected setText(text: string) {
        this.textValue = text;
        if (this.text) {
            this.text.setText(text);

            // MultiStyleText doesn't do this automatically.
            (this.text.getTargets()[0] as MultiStyleText).resetAutoShrink();
        }
    }

    protected refresh() {
        if (FooterComponent.layer === null) {
            FooterComponent.layer = Layers.Footer;
        }

        this.text = FooterComponent.layer.getFlexiText("value");
        this.setText(this.textValue);
    }
}
